/* eslint-disable react/prop-types */
import React, { Component } from 'react'
import { Button } from 'react-bootstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faAngleDoubleUp, faAngleDoubleDown } from '@fortawesome/free-solid-svg-icons'

require('../styles/SbExpander.css')

class SbExpander extends Component {
  constructor() {
    super()
    this.state = {
      open:true,
      disabled: false,
      collapsedHeight: 200
    }

    this.initialized = false
    this.toggle = this.toggle.bind(this)
  }

  initialize() {
    if (this.initialized) return
    const collapsedHeight = this.props.collapsedHeight ? this.props.collapsedHeight : 200
    const minHeightToCollapse = this.props.minHeightToCollapse ? this.props.minHeightToCollapse : collapsedHeight + 100

    if (this.originalHeight < minHeightToCollapse) {
      this.setState({ disabled: true })
    }
    else {
      this.setState({
        open: false,
        collapsedHeight : collapsedHeight
      })
    }
    this.initialized = true
  }

  componentDidMount() {
    const height = this.divSbExpanderContent.clientHeight
    if (this.state.open && !this.initialized) {
      this.originalHeight = height
      this.initialize()
    }
    this.setState({ height })
  }

  toggle(){
    this.setState({ open: !this.state.open })
  }

  render() {
    const {expanderLabel, children} = this.props
    const contentStyle = (this.state.open || this.state.disabled) ? {height:'auto'} : {height : this.state.collapsedHeight}

    if (this.state.disabled) {
      return (
        <div>
          {children}
        </div>
      )
    }

    return (
      <div className="sb-expander">
        <div className="sb-expander-content" style={contentStyle}  ref={ (divElement) => this.divSbExpanderContent = divElement}>
          {children}
          {(this.state.open || this.state.disabled) ? '' : <div className="sb-expander-fader"></div> }
        </div>
        <div className="sb-expander-button">
          <Button onClick={this.toggle} className="sb-btn-read-more">
            {this.state.open
              ? <span><FontAwesomeIcon icon={faAngleDoubleUp} fixedWidth /><FontAwesomeIcon icon={faAngleDoubleUp} fixedWidth />... show less ... </span>
              : <span><FontAwesomeIcon icon={faAngleDoubleDown} fixedWidth /><FontAwesomeIcon icon={faAngleDoubleDown} fixedWidth />... show more ... </span>}
            {expanderLabel ? expanderLabel : ''}
          </Button>
        </div>

      </div>
    )
  }
}

export default SbExpander